import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const ReceiptItem = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M21.0645 5V7.42C21.0645 9 20.0645 10 18.4845 10H15.0645V3.01C15.0645
                1.9 15.9745 1 17.0845 1C18.1745 1.01 19.1745 1.45 19.8945 2.17C20.6145 2.9 21.0645 3.9 21.0645 5Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.06445 6V20C1.06445 20.83 2.00445 21.3 2.66445 20.8L4.37445 19.52C4.77445 19.22 5.33445
                19.26 5.69445 19.62L7.35445 21.29C7.74445 21.68 8.38445 21.68 8.77445 21.29L10.4545 19.61C10.8045
                19.26 11.3645 19.22 11.7545 19.52L13.4645 20.8C14.1245 21.29 15.0645 20.82 15.0645 20V3C15.0645
                1.9 15.9645 1 17.0645 1H6.06445H5.06445C2.06445 1 1.06445 2.79 1.06445 5V6Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.06445 12.0098H11.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.06445 8.00977H11.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.06055 12H5.06953'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.06055 8H5.06953'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    ReceiptItem,
    'receipt-item',
);
